var formatEmail = function (_a) {
    var emailAddress = _a.emailAddress, allowedLength = _a.allowedLength;
    var _b = emailAddress.split('@'), userName = _b[0], domain = _b[1];
    if (userName.length > allowedLength) {
        return [
            true,
            "".concat(userName.split('').splice(0, allowedLength).join(''), "..."),
            "@".concat(domain)
        ];
    }
    return [false, emailAddress, ''];
};
export default formatEmail;
